import React from 'react';
import { motion } from 'framer-motion';
import SocialSvgGetter from '../svgs/SocialSvgGetter';

const ContactUS = () => {
  return (
    <motion.div
      className="bg-white/50 py-20 text-center text-[#3D587D] relative overflow-hidden"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1 }}
    >
      <div className="container mx-auto px-4">
        <motion.h2 
          className="text-3xl font-bold mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          联系我们
        </motion.h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          <motion.div 
            className="flex flex-col items-center justify-start"
            initial={{ opacity: 0, x: "50%" }}
            animate={{ opacity: 1, x: "0%" }}
            transition={{ delay: 0.4, type: "spring", stiffness: 100, damping: 20 }}
          >
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-4">
              {SocialSvgGetter.email}
            </div>
            <h3 className="text-xl font-semibold mb-3">邮箱</h3>
            <p className="text-[#407CBD] hover:text-[#3D587D] transition-colors cursor-pointer">
              info@ctrlcv.com
            </p>
          </motion.div>
          
          <motion.div 
            className="flex flex-col items-center justify-start"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.3 }}
          >
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-4">
              {SocialSvgGetter.wechat}
            </div>
            <h3 className="text-xl font-semibold mb-3">微信</h3>
            <motion.div 
              className="w-36 h-36 bg-white rounded-2xl flex items-center justify-center p-2 shadow-lg hover:shadow-xl transition-shadow"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <img 
                src="/QR code/wechat.jpg" 
                alt="WeChat QR Code" 
                className="w-full h-full object-contain rounded-xl"
              />
            </motion.div>
          </motion.div>
          
          <motion.div 
            className="flex flex-col items-center justify-start"
            initial={{ opacity: 0, x: "-50%" }}
            animate={{ opacity: 1, x: "0%" }}
            transition={{ delay: 0.4, type: "spring", stiffness: 100, damping: 20 }}
          >
            <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center mb-4">
              {SocialSvgGetter.xiaohongshu}
            </div>
            <h3 className="text-xl font-semibold mb-3">小红书</h3>
            <motion.div 
              className="w-36 h-36 bg-white rounded-2xl flex items-center justify-center p-2 shadow-lg hover:shadow-xl transition-shadow"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <img 
                src="/QR code/xiaohongshu.jpg" 
                alt="Xiaohongshu QR Code" 
                className="w-full h-full object-contain rounded-xl"
              />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactUS; 